import { render, staticRenderFns } from "./RankLongevityResume.vue?vue&type=template&id=74e42a1e&scoped=true"
import script from "./RankLongevityResume.vue?vue&type=script&lang=js"
export * from "./RankLongevityResume.vue?vue&type=script&lang=js"
import style0 from "./RankLongevityResume.vue?vue&type=style&index=0&id=74e42a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e42a1e",
  null
  
)

export default component.exports